import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="text-2xl font-display text-primary-500">
              非麻瓜漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer">
                分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg shadow-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-base`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
              <i className="ri-bookmark-line text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === "/"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700"
              }`}
            >
              首页
            </Link>
            <div className="text-sm font-medium text-foreground-500 px-4 py-2">
              漫画分类
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors"
              >
                <i className={`${cat.icon} mr-2 text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}